module.exports = __webpack_public_path__ + "static/img/flower4.ed618af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/flower4.png
// module id = qCR9
// module chunks = 0